module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Solid Flow Consulting","short_name":"Solid Flow Consulting","start_url":"https://solidflowconsulting.fi","scope":"https://solidflowconsulting.fi","icon":"src/images/favicon.png","legacy":true,"display":"browser"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
